import React from 'react';
import { Container, Usuario } from './styles';
import MenuAtalhos from '../MenuAtalhos';
import UsuarioInfo from '../UsuarioInfo';

export default function MenuLateral() {
  return (
    <Container>
      <Usuario>
        <UsuarioInfo />
      </Usuario>
      <MenuAtalhos />
    </Container>
  );
}
